// extracted by mini-css-extract-plugin
export default {"header":"QH","discountBanner":"RH","logo":"SH","maincontainer":"TH","videocontainer":"UH","videowelcome":"VH","videowrapper":"WH","videosale":"XH","loadingcontainer":"YH","footer":"ZH","footerbutton":"aI","video":"bI","logoname":"cI"};
    if(module.hot) {
      // 1726593106330
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  